/*
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/
const homePageSetting = resolve =>
  require(['../../../views/personalCenter/homePageSetting'], resolve)

// 咨询-咨询频道
export default [
  // 咨询频道
  {
    path: '/homepagesetting',
    component: homePageSetting
  }
]



// WEBPACK FOOTER //
// ./src/router/page/personalCenter/homePageSetting.js